import { createAction } from '@reduxjs/toolkit';
import { createActionWithCallback } from 'core/store/utils';
import { RequestError, Reason, ReasonCreationParams, ReasonUpdateParams } from 'types';

export const createReason = createActionWithCallback<void, Error>()(
  'reason/create-reason',
  (reason: ReasonCreationParams) => ({
    payload: reason,
  })
);

export const createdReason = createAction('reason/created-reason', (data?: Reason, error?: RequestError) => ({
  payload: error || data,
  error: Boolean(error),
}));

export const updateReason = createActionWithCallback<void, Error>()(
  'reason/update-reason',
  (reason: ReasonUpdateParams) => ({
    payload: reason,
  })
);

export const updatedReason = createAction('reason/updated-reason', (data?: Reason, error?: RequestError) => ({
  payload: error || data,
  error: Boolean(error),
}));

export const deleteReason = createAction('reason/delete-reason', (id: string) => ({
  payload: undefined,
  meta: { id },
}));

export const deletedReason = createAction('reason/deleted-reason', (data?: boolean, error?: RequestError) => ({
  payload: error || data,
  error: Boolean(error),
}));

export default {
  createReason,
  createdReason,
  updateReason,
  updatedReason,
  deleteReason,
  deletedReason,
};
